// extracted by mini-css-extract-plugin
export default {"mapArea":"MapLoader_mapArea__R7hP6","map":"MapLoader_map__XuJVP","map--fetching":"MapLoader_map--fetching__tcjPF","loadingOverlay":"MapLoader_loadingOverlay__67BAX"};